import React from 'react';
import './App.css';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AdminLayout from './layouts/AdminLayout';
import Dashboard from './pages/Dashboard';
import MarketingFlow from './pages/MarketingFlow';
import CommissionManagement from './pages/CommissionManagement';
import MobileEmployeeApp from './pages/mobile/EmployeeApp';
import MobileCustomerApp from './pages/mobile/CustomerApp';
import CustomerProfile from './pages/mobile/CustomerProfile';
import EmployeePromotion from './pages/mobile/EmployeePromotion';
import CustomerListPage from './pages/mobile/CustomerListPage';
import CommissionDetailPage from './pages/mobile/CommissionDetailPage';
import SendPromotionPage from './pages/mobile/SendPromotionPage';
import EmployeeManagement from './pages/EmployeeManagement';
import CommissionConfigManagement from './pages/CommissionConfigManagement';
import CommissionAuditManagement from './pages/CommissionAuditManagement';
import DataMonitoringDashboard from './pages/DataMonitoringDashboard';
import ActivityCenterManagement from './pages/ActivityCenterManagement';
import BindButlerSuccessPage from './pages/mobile/BindButlerSuccessPage';
import MyButlerPage from './pages/mobile/MyButlerPage';
import InventoryAlertNotifications from './pages/mobile/notifications/InventoryAlertNotifications';
import InventoryAlertAnalysis from './pages/mobile/notifications/InventoryAlertAnalysis';
import OrderSpeedChangeAlert from './pages/mobile/notifications/OrderSpeedChangeAlert';
import PriceChangeAlert from './pages/mobile/notifications/PriceChangeAlert';
import ButlerBindingDetails from './pages/ButlerBindingDetails';
import CustomerManagement from './pages/CustomerManagement';
import ButlerPerformanceAnalysis from './pages/ButlerPerformanceAnalysis';
import ConsumptionConversionAnalysis from './pages/ConsumptionConversionAnalysis';
import RepurchaseRetentionAnalysis from './pages/RepurchaseRetentionAnalysis';
import ExceptionOrderManagement from './pages/ExceptionOrderManagement';
import HotelServicePage from './pages/mobile/HotelServicePage';

function App() {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#529C8A',
          borderRadius: 2,
        },
      }}
    >
      <Router>
        <Routes>
          <Route path="/" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="/employee" element={<EmployeeManagement />} />
            <Route path="/customer" element={<CustomerManagement />} />
            <Route path="/marketing-flow" element={<MarketingFlow />} />
            <Route path="/commission" element={<CommissionManagement />} />
            <Route path="/commission-config" element={<CommissionConfigManagement />} />
            <Route path="/commission-audit" element={<CommissionAuditManagement />} />
            <Route path="/exception-order" element={<ExceptionOrderManagement />} />
            <Route path="/data-monitoring" element={<DataMonitoringDashboard />} />
            <Route path="/activity-center" element={<ActivityCenterManagement />} />
            <Route path="/butler-binding-details" element={<ButlerBindingDetails />} />
            <Route path="/butler-performance" element={<ButlerPerformanceAnalysis />} />
            <Route path="/consumption-conversion" element={<ConsumptionConversionAnalysis />} />
            <Route path="/repurchase-retention" element={<RepurchaseRetentionAnalysis />} />
            <Route path="/mobile-preview/employee" element={<MobileEmployeeApp />} />
            <Route path="/mobile-preview/customer" element={<MobileCustomerApp />} />
            <Route path="/mobile-preview/profile" element={<CustomerProfile />} />
            <Route path="/mobile-preview/promotion" element={<EmployeePromotion />} />
            <Route path="/mobile-preview/customers" element={<CustomerListPage />} />
            <Route path="/mobile-preview/commissions" element={<CommissionDetailPage />} />
            <Route path="/mobile-preview/bind-butler-success" element={<BindButlerSuccessPage />} />
            <Route path="/mobile-preview/my-butler" element={<MyButlerPage />} />
            <Route path="/mobile-preview/send-promotion" element={<SendPromotionPage />} />
            <Route path="/mobile-preview/hotel-service" element={<HotelServicePage />} />
            <Route path="/mobile-preview/inventory-alerts" element={<InventoryAlertNotifications />} />
            <Route path="/mobile-preview/inventory-alert/:id" element={<InventoryAlertAnalysis />} />
            <Route path="/mobile-preview/order-speed-alert/:id" element={<OrderSpeedChangeAlert />} />
            <Route path="/mobile-preview/price-change-alert/:id" element={<PriceChangeAlert />} />
          </Route>
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;
